module.exports = __webpack_public_path__ + "media/images/webpage/specials/huistenbosch_2020/sp-cover-3-cfeb81bb2bd5b57c352431d3d3e24c1c.webp";